import VueRouter from 'vue-router';

import store from '@/store';

import { isAuthenticated, getLoginUrl, getToken } from '../utils/auth';
import { normalizeUrl } from '../utils/index';

// Used Components
import NewSearch from '@/views/NewSearch';
import NewContentEditor from '@/views/NewContentEditor';
import SEOContentEditor from '@/views/SEOContentEditor';

const { getPermissions } = require('../utils/permissions');

const routes = [
  // { path: '/home', name: 'home', component: Home, meta: { componentName: 'Home' } },
  { path: '/', name: 'home', component: NewSearch, meta: { componentName: 'NewSearch', folderRoute: true } },
  { path: '/folders*', name: 'folders', component: NewSearch, meta: { componentName: 'NewSearch', folderRoute: true } },
  { path: '/search/:searchText?', name: 'search', component: NewSearch, meta: { componentName: 'NewSearch' } },
  { path: '/content/:wtype/:uuid?', name: 'ContentEditor', component: NewContentEditor, meta: { componentName: 'NewContentEditor', keepAlive: true } },
  { path: '/content/seo/:wtype/:uuid?', name: 'SEOContentEditor', component: SEOContentEditor, meta: { componentName: 'SEOContentEditor', seoRoute: true, keepAlive: true } }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve(async (to, from, next) => {
  const isLogged = await isAuthenticated(getToken(), window.location.origin);

  if (!isLogged) {
    window.localStorage.clear();
    window.location.href = getLoginUrl(window.location.origin, store.getters.enviroment.VUE_APP_SSO_CLIENT_ID);
    return;
  }

  const normalizedPath = normalizeUrl(to.path);

  if (normalizedPath !== to.path) {
    router.replace({ path: normalizedPath, query: to.query });
    return;
  }

  return next();
});

router.beforeEach(async (to, from, next) => {
  const user = store.state.currentUser;

  if (from.name !== null) {
    if (!to.meta.keepAlive) { // If the route is not a keep-alive route, keep-alive the component of the route it's going to
      store.commit('setInclude', [to.meta.componentName]);
    }
  }

  if (user) {
    if (to.meta.allowedRoles) {
      if (to.meta.workspaces) {
        const currentWorkspace = store.getters.workspace;
        const canGo = getPermissions(to.meta.allowedRoles, user.roles, to.meta.workspaces, currentWorkspace);

        if (!canGo) {
          next({ name: 'home' });
        }
      }
    }
  }

  next();
});

export default router;
